export const privilegeColors: Record<string, string> = {
  high: 'bg-red-500/20 text-red-300 border-red-500/30',
  medium: 'bg-amber-500/20 text-amber-300 border-amber-500/30',
  low: 'bg-emerald-500/20 text-emerald-300 border-emerald-500/30',
};

export function getPrivilegeBadge(level: number): { label: string; color: string } {
  if (level >= 800) return { label: 'High', color: privilegeColors.high };
  if (level >= 400) return { label: 'Medium', color: privilegeColors.medium };
  return { label: 'Low', color: privilegeColors.low };
}
